export default {
  scenes: {
    familiarHabits: {
      beats: {
        usualMorning: {
          events: [
            {
              type: 'showLocation',
              locationId: 'baliCafe'
            },
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'neutral',
              text: "It's been weeks now, and the morning coffee runs are no longer coincidence—they are just… routine. Reina notices how natural it's become.",
              choices: [
                {
                  text: 'Acknowledge It Playfully',
                  next: {
                    scene: 'familiarHabits',
                    beat: 'acknowledgePlaying'
                  }
                },
                {
                  text: 'Ignore It, Keep Things Normal',
                  next: {
                    scene: 'familiarHabits',
                    beat: 'ignoreNormal'
                  }
                }
              ]
            }
          ]
        },
        acknowledgePlaying: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'happy',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'happy',
              text: "You do realize this is basically a standing meeting now, right?"
            },
            {
              type: 'showCharacter',
              characterId: 'eric',
              variation: 'happy',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'happy',
              text: "Best meeting of the day."
            },
            {
              type: 'hideCharacter',
              characterId: 'eric',
              position: 'center'
            }
          ],
          next: {
            scene: 'familiarHabits',
            beat: 'unspokenExpectations'
          }
        },
        ignoreNormal: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'neutral',
              text: "So, what's on the agenda today?"
            },
            {
              type: 'showCharacter',
              characterId: 'eric',
              variation: 'happy',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'happy',
              text: "Saving the world, one coffee at a time."
            },
            {
              type: 'hideCharacter',
              characterId: 'eric',
              position: 'center'
            }
          ],
          next: {
            scene: 'familiarHabits',
            beat: 'unspokenExpectations'
          }
        },
        unspokenExpectations: {
          events: [
            {
              type: 'showNarration',
              text: "For the first time, Reina wonders—if she didn't show up, would he wait for her? But she doesn't ask. And neither does he."
            },
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'thinking',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'thinking',
              text: "You ever think about what happens when this project's over?"
            },
            {
              type: 'showCharacter',
              characterId: 'eric',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'neutral',
              text: "Guess we go back to our real lives."
            }
          ],
          next: {
            scene: 'teamOuting',
            beat: 'groupAdventure'
          }
        }
      }
    },
    teamOuting: {
      beats: {
        groupAdventure: {
          events: [
            {
              type: 'showLocation',
              locationId: 'baliBeach'
            },
            {
              type: 'showNarration',
              text: "The team decides to take a weekend trip to explore more of Bali. It's a break from work, a chance to just enjoy the moment."
            },
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'neutral',
              text: "What activity should I choose?",
              choices: [
                {
                  text: 'Join the Hike with Eric',
                  next: {
                    scene: 'teamOuting',
                    beat: 'joinHike'
                  }
                },
                {
                  text: 'Go with the Others to the Market',
                  next: {
                    scene: 'teamOuting',
                    beat: 'goMarket'
                  }
                }
              ]
            }
          ]
        },
        joinHike: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'happy',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'happy',
              text: "I'll take a trail over a crowded beach any day."
            },
            {
              type: 'showCharacter',
              characterId: 'eric',
              variation: 'happy',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'happy',
              text: "Alright. Let's see if you can keep up."
            },
            {
              type: 'hideCharacter',
              characterId: 'eric',
              position: 'center'
            }
          ],
          next: {
            scene: 'teamOuting',
            beat: 'unexpectedView'
          }
        },
        goMarket: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'happy',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'happy',
              text: "I heard the local markets are amazing."
            },
            {
              type: 'showCharacter',
              characterId: 'eric',
              variation: 'happy',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'happy',
              text: "Bring me back something cool."
            },
            {
              type: 'hideCharacter',
              characterId: 'eric',
              position: 'center'
            }
          ],
          next: {
            scene: 'teamOuting',
            beat: 'missedMoment'
          }
        },
        unexpectedView: {
          events: [
            {
              type: 'showLocation',
              locationId: 'baliHill'
            },
            {
              type: 'showNarration',
              text: "Reina and Eric find themselves at the top of a hill, overlooking the coastline. For a moment, they just stand there, quiet."
            },
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'thinking',
              position: 'left'
            },
            {
              type: 'showCharacter',
              characterId: 'eric',
              variation: 'thinking',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'thinking',
              text: "This is… kind of unreal."
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'thinking',
              text: "Yeah. It is."
            }
          ],
          next: {
            scene: 'lateNightConfessions',
            beat: 'drunkenBet'
          }
        },
        missedMoment: {
          events: [
            {
              type: 'showLocation',
              locationId: 'baliBeach'
            },
            {
              type: 'showNarration',
              text: "Reina enjoys the outing with the others, but something feels… slightly off. When she returns, she notices Eric alone by the shore, lost in thought."
            },
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'thinking',
              position: 'left'
            },
            {
              type: 'showCharacter',
              characterId: 'eric',
              variation: 'thinking',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'thinking',
              text: "You disappeared early."
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'thinking',
              text: "Just needed some space."
            }
          ],
          next: {
            scene: 'lateNightConfessions',
            beat: 'drunkenBet'
          }
        }
      }
    },
    lateNightConfessions: {
      beats: {
        drunkenBet: {
          events: [
            {
              type: 'showLocation',
              locationId: 'baliBar'
            },
            {
              type: 'showNarration',
              text: "Later that night, the team unwinds at a beachside bar. Someone suggests a game—truth or dare. Reina gets pulled in."
            },
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'neutral',
              text: "Truth or dare?",
              choices: [
                {
                  text: 'Truth',
                  next: {
                    scene: 'lateNightConfessions',
                    beat: 'truthChoice'
                  }
                },
                {
                  text: 'Dare',
                  next: {
                    scene: 'lateNightConfessions',
                    beat: 'dareChoice'
                  }
                }
              ]
            }
          ]
        },
        truthChoice: {
          events: [
            {
              type: 'showDialog',
              speaker: 'teammate',
              variation: 'neutral',
              text: "What's one thing you've never admitted out loud?"
            },
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'thinking',
              position: 'left'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'thinking',
              text: "…That I don't know where I'm supposed to be."
            },
            {
              type: 'showCharacter',
              characterId: 'eric',
              variation: 'thinking',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'thinking',
              text: "That's a tough one."
            }
          ],
          next: {
            scene: 'lateNightConfessions',
            beat: 'closeCall'
          }
        },
        dareChoice: {
          events: [
            {
              type: 'showDialog',
              speaker: 'teammate',
              variation: 'neutral',
              text: "I dare you to pick someone here and tell them what you really think of them."
            },
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'happy',
              position: 'left'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'happy',
              text: "Easy."
            },
            {
              type: 'showCharacter',
              characterId: 'eric',
              variation: 'happy',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'happy',
              text: "Oh, this should be good."
            }
          ],
          next: {
            scene: 'lateNightConfessions',
            beat: 'closeCall'
          }
        },
        closeCall: {
          events: [
            {
              type: 'showNarration',
              text: "At some point in the night, Reina and Eric step away from the group. The air feels different—maybe it's the drinks, or maybe it's just them."
            },
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'thinking',
              position: 'left'
            },
            {
              type: 'showCharacter',
              characterId: 'eric',
              variation: 'thinking',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'thinking',
              text: "You ever wonder what happens if we…"
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'thinking',
              text: "Don't start asking questions we don't have answers for."
            }
          ],
          next: {
            scene: 'lineBetweenFriends',
            beat: 'momentThatAlmostMeans'
          }
        }
      }
    },
    lineBetweenFriends: {
      beats: {
        momentThatAlmostMeans: {
          events: [
            {
              type: 'showLocation',
              locationId: 'baliBeach'
            },
            {
              type: 'showNarration',
              text: "The night is quiet again. Reina and Eric walk back along the shoreline, their footsteps barely making a sound."
            },
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'neutral',
              text: "How should I handle this shift?",
              choices: [
                {
                  text: 'Break the Tension with a Joke',
                  next: {
                    scene: 'lineBetweenFriends',
                    beat: 'breakTensionJoke'
                  }
                },
                {
                  text: 'Acknowledge the Moment, Even If Lightly',
                  next: {
                    scene: 'lineBetweenFriends',
                    beat: 'acknowledgeMoment'
                  }
                }
              ]
            }
          ]
        },
        breakTensionJoke: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'happy',
              position: 'left'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'happy',
              text: "Don't look so serious. I was probably just going to ask if you wanted another drink."
            },
            {
              type: 'showCharacter',
              characterId: 'eric',
              variation: 'happy',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'happy',
              text: "Right. Sure."
            },
            {
              type: 'showNarration',
              text: "Nothing changes. They keep laughing, keep talking, keep pretending nothing is different."
            }
          ],
          goToChapter: {
            chapter: 'chapter4'
          }
        },
        acknowledgeMoment: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'thinking',
              position: 'left'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'thinking',
              text: "It's strange, isn't it? How some people just… fit into your life."
            },
            {
              type: 'showCharacter',
              characterId: 'eric',
              variation: 'thinking',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'thinking',
              text: "Yeah. It is."
            },
            {
              type: 'showNarration',
              text: "Something shifts. Not enough to be spoken aloud. But enough that they both feel it."
            }
          ],
          goToChapter: {
            chapter: 'chapter4'
          }
        }
      }
    }
  }
}
